"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _polished = require("../../helpers/polished");
var _styled = require("../../styled");
var _fonts = require("../fonts");
var _baseTheme = require("./baseTheme");
var _templateObject;
var rem = function rem(size) {
  return (0, _polished.rem)(size, _baseTheme.basePixelSize);
};
var gutterWidth = rem(15);
var colors = {
  black: '#1A1919',
  middleGrey: '#8D8D8D',
  darkGrey: '#666666',
  blue: '#37559C',
  grey: '#DDDCDB',
  lightGrey: '#f3f3f3',
  borderGrey: '#E2E3DF',
  offWhite: '#F9F9F9',
  white: '#fff',
  yellow: '#E5C936',
  green: '#7DB552'
};
var contextualColors = {
  primary: colors.black,
  secondary: colors.middleGrey,
  backgroundPrimary: colors.white,
  backgroundDark: colors.black,
  backgroundLight: colors.offWhite,
  backgroundSecondary: colors.lightGrey,
  borderColor: colors.borderGrey,
  paletteColor: colors.middleGrey,
  facebook: colors.blue,
  footerBackground: colors.grey,
  keyboardBackground: colors.grey,
  tooltip: colors.yellow,
  step: colors.darkGrey,
  iconColor: colors.black
};
var fonts = {
  base: 'Apercu,arial,sans-serif',
  headline: 'Apercu,arial,sans-serif',
  subHeadline: 'Apercu,arial,sans-serif',
  paragraph: 'Apercu,arial,sans-serif'
};
var baseTypography = {
  fontFamily: fonts.base,
  headlineFontFamily: fonts.headline,
  lineHeight: 1.5,
  marginBottom: rem(1)
};
var typography = {
  pageTitle: {
    fontFamily: baseTypography.headlineFontFamily,
    fontWeight: 400,
    fontSize: rem(28),
    fontSizeLarge: rem(40),
    lineHeight: baseTypography.lineHeight,
    lineHeightLarge: rem(42),
    marginBottom: baseTypography.marginBottom,
    textTransform: 'uppercase',
    letterSpacing: rem(3)
  },
  headline: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(16),
    fontSizeLarge: rem(25),
    lineHeight: baseTypography.lineHeight,
    marginBottom: rem(5),
    textTransform: 'uppercase',
    letterSpacing: rem(1),
    color: contextualColors.primary
  },
  subHeadline: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(18),
    fontSizeLarge: rem(24),
    lineHeight: baseTypography.lineHeight,
    marginBottom: rem(0.5)
  },
  preamble: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 400,
    fontSize: rem(15),
    lineHeight: 1.375,
    fontSizeDesktop: rem(15),
    lineHeightDesktop: 1.44,
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'none',
    color: colors.darkGrey
  },
  paragraph: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(14),
    fontSizeLarge: rem(15),
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    color: colors.darkGrey
  },
  pageDescription: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(18),
    fontSizeLarge: rem(20),
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom
  },
  helpText: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(20),
    fontSizeLarge: rem(24),
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom
  },
  statusText: {
    fontFamily: baseTypography.fontFamily,
    fontSize: rem(16),
    fontSizeLarge: rem(16),
    lineHeight: baseTypography.lineHeight,
    marginBottom: baseTypography.marginBottom,
    marginTop: '0.5rem'
  }
};
var button = {
  borderRadius: 0,
  fontFamily: baseTypography.fontFamily,
  fontSize: rem(14),
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: rem(1.2),
  colors: {
    primaryColor: colors.white,
    primaryBackground: colors.black,
    secondaryColor: colors.white,
    secondaryBackground: colors.darkGrey
  },
  margin: '0',
  siblingMargin: gutterWidth
};
var forms = {
  colors: {
    selected: colors.black
  }
};
var tooltip = {
  colors: {
    primaryColor: colors.white,
    primaryBackground: colors.green
  }
};
var GlobalStyles = (0, _styled.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n  :root {\n    font: 400 ", "px/1.43 \"Apercu\", Arial, sans-serif;\n  }\n  body {\n    padding: 0;\n    margin: 0;\n    font-family: \"Apercu\", Arial, sans-serif;\n  }\n"])), _fonts.keittiomaailmaFonts, _baseTheme.basePixelSize);
var theme = {
  basePixelSize: _baseTheme.basePixelSize,
  GlobalStyles: GlobalStyles,
  typography: typography,
  fonts: fonts,
  tooltip: tooltip,
  button: button,
  forms: forms,
  colors: Object.assign({}, colors, contextualColors)
};
var _default = exports.default = theme;